import React from 'react';
import PropTypes from 'prop-types';

// components
import { FormattedMessage } from 'react-intl';
import ArrowRight from 'dibs-vg/dist/react/arrow-right';

// styles
import styles from './PdpSharedMakerHeadshotModule.scss';

// helpers
import get from 'lodash.get';

const viewProfile = (
    <FormattedMessage id="PdpSharedMakerHeadshotModule.viewProfile" defaultMessage="View Profile" />
);

function PdpSharedMakerHeadshotModule({ seller, liveStorefront }) {
    const name = get(seller, 'sellerProfile.company');
    const urlLabel = get(seller, 'sellerPreferences.urlLabel');

    const photos = get(liveStorefront, 'photos') || [];
    const headshot = photos.find(photo => get(photo, 'type.name') === 'DEALER_STOREFRONT_HEADSHOT');

    return (
        <div className={styles.wrapper}>
            {/* Headshot */}
            {!!(headshot && headshot.path) && (
                <div className={styles.imageWrap}>
                    <img className={styles.image} src={headshot.path} alt={name} />
                </div>
            )}
            {/* Name / View Profile link */}
            <div>
                <p className={styles.name}>{name}</p>
                <a href={`/dealers/${urlLabel}/`}>
                    {viewProfile}
                    <ArrowRight className={styles.arrow} />
                </a>
            </div>
        </div>
    );
}

PdpSharedMakerHeadshotModule.propTypes = {
    seller: PropTypes.object.isRequired,
    liveStorefront: PropTypes.object,
};

export { PdpSharedMakerHeadshotModule };
